<script setup>
// NOTICE: KAPTION-INTEGRATION
import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store.js';
import Icon from 'next/icon/Icon.vue';

const props = defineProps({
  to: { type: [Object, String], default: '' },
  label: { type: String, default: '' },
  icon: { type: [String, Object], default: '' },
  expandable: { type: Boolean, default: false },
  isActive: { type: Boolean, default: false },
  hasActiveChild: { type: Boolean, default: false },
  getterKeys: { type: Object, default: () => ({}) },
});

const emit = defineEmits(['toggle']);

const showBadge = useMapGetter(props.getterKeys.badge);
const dynamicCount = useMapGetter(props.getterKeys.count);
const count = computed(() =>
  dynamicCount.value > 99 ? '99+' : dynamicCount.value
);
</script>

<template>
  <component
    :is="to ? 'router-link' : 'div'"
    v-tooltip.right="label"
    class="flex items-center justify-center size-10 rounded-full relative"
    role="button"
    draggable="false"
    :to="to"
    :title="label"
    :class="{
      'text-n-blue-text bg-n-alpha-2 font-medium': isActive || hasActiveChild,
      'text-n-slate-11 hover:bg-n-alpha-2': !isActive && !hasActiveChild,
    }"
    @click.stop="emit('toggle')"
  >
    <Icon v-if="icon" :icon="icon" class="size-5" />
    <span
      v-if="showBadge"
      class="size-2 top-1 ltr:right-1 rtl:left-1 bg-n-brand absolute rounded-full border border-n-solid-2"
    />
    <span
      v-if="dynamicCount && !expandable"
      class="absolute -top-1 -right-1 rounded-full text-[10px] leading-none font-semibold text-center bg-n-brand text-white size-4 flex items-center justify-center border border-n-solid-2"
    >
      {{ count }}
    </span>
  </component>
</template>
